import { FormikProps } from "formik";
import { ForwardedRef, useImperativeHandle } from "react";

import { FormWrapperHandle } from "./BaseEntityCreateUpdate";
import {
  BaseEntityCreateUpdateGuards,
  BaseEntityCreateUpdateGuardsProps,
} from "./BaseEntityCreateUpdateGuards";

export interface BaseEntityCreateUpdateExtrasProps {
  /** Defines default imperative handle. */
  defaultImperativeHandle?: {
    formWrapperRef?: ForwardedRef<FormWrapperHandle | null>;
    formikProps?: FormikProps<any>;
  };
  /** Defines default guards. */
  guardProps?: BaseEntityCreateUpdateGuardsProps;
}

/** Encapsulates extra opt-in features. */
export function BaseEntityCreateUpdateExtras({
  defaultImperativeHandle,
  guardProps,
}: BaseEntityCreateUpdateExtrasProps) {
  // define default imperative handle
  useImperativeHandle(
    defaultImperativeHandle?.formWrapperRef || undefined,
    () =>
      ({
        formInfo: {
          isDirty: defaultImperativeHandle?.formikProps?.dirty ?? false,
        },
      }) satisfies FormWrapperHandle,
    [defaultImperativeHandle?.formWrapperRef, defaultImperativeHandle?.formikProps?.dirty],
  );

  // guards
  return <>{guardProps && <BaseEntityCreateUpdateGuards {...guardProps} />}</>;
}
